import { gql } from '@apollo/client';

export default gql`
  query businessAccountStatus($accountNumber: String!) {
    businessAccountStatus(accountNumber: $accountNumber)
  }
`;
